export default [
  {
    header: 'Coordinación',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Pénsums',
    route: 'coordinador-pensums',
    icon: 'BookOpenIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Competencias Docentes',
    route: 'coordinador-competencies',
    icon: 'AwardIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Periodos Académicos',
    route: 'coordinador-periods',
    icon: 'CalendarIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Programación Académica',
    route: 'coordinador-scheduling',
    icon: 'FileTextIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Horarios y Asignaciones',
    route: 'coordinador-assignments',
    icon: 'GridIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Calendario de Evaluaciones',
    icon: 'CalendarIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
    children: [
      {
        title: 'Programar Evaluaciones',
        route: 'coordinador-programar-evaluaciones',
        icon: 'EditIcon',
        resource: 'CoordinadorSubject',
        action: 'manage',
      },
      {
        title: 'Reporte de Evaluaciones',
        route: 'coordinador-reporte-evaluaciones',
        icon: 'FileTextIcon',
        resource: 'CoordinadorSubject',
        action: 'manage',
      },
    ],
  },
  {
    title: 'Reporte de Asignaciones',
    route: 'coordinador-assignments-3',
    icon: 'GridIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Carga de Catedráticos',
    route: 'coordinador-carga-catedraticos',
    icon: 'UsersIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
  {
    title: 'Validaciones',
    route: 'coordinador-validations',
    icon: 'AlertTriangleIcon',
    resource: 'CoordinadorSubject',
    action: 'manage',
  },
]
